import { userList } from "constants/user";
import * as API from "../API/index";
import { authorizedUser } from "components/CommonComponent/CommonFunction";

export const addUser = async (bodyData) => {
  try {
    const res = await API.add_user(bodyData);
    return res?.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export const getUserList = async (dispatch, pageNum, filters) => {
  try {
    const res = await API.user_list(pageNum, filters);
    dispatch({ type: userList, payload: res?.data });
  } catch (error) {
    dispatch({
      type: userList,
      payload: error?.response?.data || error,
    });
    authorizedUser(error.response?.data);
  }
};

export const getUserById = async (id) => {
  try {
    const res = await API.get_user_by_ID(id);
    return res?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

export const updateUserById = async (id, bodyData) => {
  try {
    const res = await API.edit_user(id, bodyData);
    return res?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

export const deleteUserById = async (id) => {
  try {
    const res = await API.delete_user_by_ID(id);
    return res?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
}